export default "__VITE_PUBLIC_ASSET__7cc0d045__"